<div *ngIf="loading()" class="main-container d-flex justify-content-center align-items-center">
  <app-progress-spinner> </app-progress-spinner>
</div>

<form class="p-2 d-flex flex-column" *ngIf="!loading()" (submit)="onSubmit()" [formGroup]="createAppForm">
  <div *ngIf="showDraftModeToggle" class="form-check form-switch mb-2">
    <input formControlName="draftMode" class="form-check-input" type="checkbox" id="draft-mode" />
    <label class="form-check-label" for="draft-mode">Modo Rascunho</label>
  </div>

  <div class="row mb-2">
    <div class="col-md-4">
      <label for="accountant-id">Id do Contador</label>
      <div class="input-group mb-1">
        <input [readOnly]="!!savedConfigurations()" maxlength="36" formControlName="accountantId"
          class="form-control" id="accountant-id" type="text" />
      </div>

      <label for="name">Nome do App</label>
      <div class="input-group mb-1">
        <input formControlName="name" class="form-control" id="name" type="text" />
      </div>

      <label for="one-signal-app-id">One Signal App ID</label>
      <div class="input-group mb-1">
        <input
          formControlName="oneSignalAppId"
          class="form-control"
          id="one-signal-app-id"
          type="text"
        />
      </div>
      <div *ngIf="createAppForm.controls['oneSignalAppId'].invalid && (createAppForm.controls['oneSignalAppId'].dirty || createAppForm.controls['oneSignalAppId'].touched)">
        <small class="text-danger" *ngIf="createAppForm.controls['oneSignalAppId'].hasError('required')">This field is required.</small>
         </div>

      <label for="color">Color</label>
      <div class="input-group mb-1">
        <input maxlength="7" placeholder="#002D72" formControlName="color" class="form-control" id="color" type="text" />
        <small class="text-danger" *ngIf="createAppForm.controls['color'].hasError('invalidAccentColor')">Use um hexadecimal de 6 dígitos, como #002D72.</small>
      </div>

      <label for="color">Versão de Marketing</label>
      <div class="input-group mb-1">
        <input formControlName="versionName" class="form-control" id="color" type="text" />
      </div>
    </div>
    <div class="col-md-4">
      <label for="deep-link">Deep Link</label>
      <div class="input-group mb-1">
        <input formControlName="deepLink" class="form-control" id="deep-link" type="text" />
      </div>

      <label for="qr-code-content">QR Code Redirect Link</label>
      <div class="input-group mb-1 align-items-center gap-1">
        <input formControlName="qrCodeContent" class="form-control" id="qr-code-content" type="text" />
        <button (click)="openQrCodeModal()" type="button" [disabled]="
            !qrCodeContent || !createAppForm.controls['accountantId'].valid
          " class="bg-transparent border-0 bg-noneclass fa-sharp fa-solid fa-qrcode"></button>

        <app-whitelabel-qrcode [accountantId]="
            createAppForm.controls['accountantId'].valid
              ? accountantId
              : undefined
          " (fetchedLinkEvent)="onFetchQrCodeLink($event)">
        </app-whitelabel-qrcode>
      </div>

      <label for="one-signal-api-key">One Signal API Key</label>
      <div class="input-group mb-1">
        <input
          formControlName="oneSignalApiKey"
          class="form-control"
          id="one-signal-api-key"
          type="text"
        />
      </div>
      <div *ngIf="createAppForm.controls['oneSignalApiKey'].invalid && (createAppForm.controls['oneSignalApiKey'].dirty || createAppForm.controls['oneSignalApiKey'].touched)">
        <small class="text-danger" *ngIf="createAppForm.controls['oneSignalApiKey'].hasError('required')">This field is required.</small>
      </div>

      <label for="color">Versão de Build</label>
      <div class="input-group mb-1">
        <input formControlName="versionCode" class="form-control" id="color" type="text" />
      </div>

      <label for="intentScheme">Intent</label>
      <div class="input-group mb-1">
        <input formControlName="intentScheme" class="form-control" id="intentScheme" type="text" />
        <input formControlName="intentUrl" class="form-control" id="intentUrl" type="text" *ngIf="intentUrl"/>
      </div>
    </div>
  </div>
  <div class="mb-2">
    <div>
      <div class="form-check form-switch">
        <input formControlName="iosSelect" class="form-check-input" type="checkbox" id="hasIos" />
        <label class="form-check-label" for="hasIos">Tem Ios</label>
      </div>
      <div [class.d-none]="!createAppForm.controls['iosSelect'].value" class="mt-2 mb-2">
        <app-whitelabel-ios-component [isDraftMode]="this.createAppForm.controls['draftMode'].value"
          [parentForm]="this.createAppForm" [isIosChecked]="createAppForm.controls['iosSelect'].value"
          [savedConfigurations]="savedConfigurations()">
        </app-whitelabel-ios-component>
      </div>
    </div>
    <div class="form-check form-switch">
      <input formControlName="androidSelect" class="form-check-input" type="checkbox" id="hasAndroid" />
      <label class="form-check-label" for="hasAndroid">Tem Android</label>
    </div>

    <div [class.d-none]="!createAppForm.controls['androidSelect'].value" class="mt-2 mb-2">
      <app-whitelabel-android-component [isDraftMode]="this.createAppForm.controls['draftMode'].value"
        [parentForm]="this.createAppForm" [isAndroidChecked]="createAppForm.controls['androidSelect'].value"
        [savedConfigurations]="savedConfigurations()" (updated)="onAndroidUpdate($event)">
      </app-whitelabel-android-component>
    </div>
  </div>
  <div class="d-inline-flex align-items-center gap-1">
    <button type="submit" class="mb-2 btn btn-primary">Salvar</button>
  </div>

  <qrcode #qrCodeImage *ngIf="qrCodeContent" [hidden]="true" [qrdata]="qrCodeContent" [width]="128"
    (qrCodeURL)="onQrCodeLoad()"></qrcode>
</form>
